<template>
  <div
    :class="{
      'slider-content-desktop-masonry': desktopType === 'masonry',
      'slider-content-desktop-grid': desktopType === 'grid',
      'slider-content-logos': desktopType === 'logos',
      'slider-content-cards': desktopType === 'cards',
      'slider-content-quotes': desktopType === 'quotes',
      'slider-content-info': desktopType === 'info',
      'one-item': parseInt(numberOfItems) === 1,
      'two-items': parseInt(numberOfItems) === 2,
      'three-items': parseInt(numberOfItems) === 3,
      'four-items': parseInt(numberOfItems) === 4,
      'five-items': parseInt(numberOfItems) === 5,
      'six-items': parseInt(numberOfItems) === 6,
      'slider-two-per-page': parseInt(props.perPage) === 2,
    }"
  >
    <div
      class="splide"
      aria-label="Text that describe group of items"
      ref="splideElmRef"
    >
      <div class="splide__track">
        <slot></slot>
      </div>
      <div class="splide__arrows">
        <button class="splide__arrow splide__arrow--prev icon--hoverable">
          <i class="icon icon-chevronleft icon-color--grey3 icon--xxs"></i>
        </button>
        <button class="splide__arrow splide__arrow--next icon--hoverable">
          <i class="icon icon-chevronright icon-color--red icon--xxs"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue';
import Splide from '@splidejs/splide';
const splideElmRef = ref();
const isLessThanDesktop = window.matchMedia(`(max-width: 991px)`);

const props = defineProps({
  desktopType: {
    type: String,
    default: 'masonry',
  },
  type: {
    type: String,
    default: 'loop',
  },
  perPage: {
    type: [Number, String],
    default: 1,
  },
  perMove: {
    type: [Number, String],
    default: 1,
  },
  arrows: {
    type: Boolean,
    default: false,
  },
  destroy: {
    type: Boolean,
    default: false,
  },
  mobileFirst: {
    type: Boolean,
    default: false,
  },
  breakpoints: {
    type: Object,
    default: null,
  },
  itemsPerDealSlide: {
    type: [Number, String],
    default: 5,
  },
  numberOfItems: {
    type: [Number, String],
    required: true,
  },
});

const init = () => {
  const options = {
    type: props.type,
    perPage: parseInt(props.perPage),
    perMove: parseInt(props.perMove),
    arrows: props.arrows,
    destroy: props.destroy,
    mediaQuery: props.mobileFirst ? 'min' : 'max',
    speed: 500,
    flickPower: 100,
    breakpoints: props.breakpoints || {
      992: {
        destroy: parseInt(props.numberOfItems) < 2,
      },
    },
  };

  if (!isLessThanDesktop.matches) {
    options.speed = 1000;
    options.easing = 'cubic-bezier(.58,0,.47,.98)';
  }

  if (splideElmRef.value) {
    requestAnimationFrame(() => {
      new Splide(splideElmRef.value, options).mount();
    });
  }
};

onMounted(() => {
  requestAnimationFrame(init);
});
</script>
